import { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { SyncPanel } from '../../../components/sync/SyncPanel';
import { StepScaffold } from '../StepScaffold';

/** Step 4 — kick off the first sync and hold Continue until it finishes, so the
 * user lands on a domain that already has data (not an empty dashboard). The step
 * is forward-only (no Back): once a sync is underway, stepping back to change
 * integrations has murky semantics and fights the per-domain sync cooldown. The
 * body is the shared SyncPanel (also used by the add-domain modal). */
export function SyncStep({
  envId,
  onDone,
  eyebrow = 'First sync',
}: {
  envId: string;
  onDone: () => void;
  eyebrow?: string;
}) {
  // Continue unlocks only once the pipeline reaches a terminal state (every
  // integration succeeded + the graph converged, or something failed).
  const [settled, setSettled] = useState(false);

  return (
    <StepScaffold
      eyebrow={eyebrow}
      title="We’re mapping your cloud"
      lead="Lizrd is reading your connected resources and building your knowledge graph. Most domains finish in a few minutes — you can safely leave this page and pick up right here when you come back."
      safety="We only read your configuration and cost data — nothing is ever modified."
      footer={
        <Button
          type="button"
          onClick={onDone}
          disabled={!settled}
          title={settled ? undefined : 'Available once your first sync finishes'}
        >
          {settled ? 'Continue' : 'Syncing…'}
        </Button>
      }
    >
      <SyncPanel envId={envId} onSettled={() => setSettled(true)} />
    </StepScaffold>
  );
}
